export function prepareExcelImage(url, position) {
	const imagePromise = webix.promise.defer();
	const regex = /data:image\/(png|jpg|jpeg);base64,/;
	const type = url.match(regex);
	if(type)
		imagePromise.resolve({
			data: url,
			position
		});
	else{
		const img = webix.html.create("img", {src: url, width:position.width+"px", height:position.height+"px"});
		img.crossOrigin = "anonymous";

		img.onerror = () =>	imagePromise.resolve();
		img.onload = function(){
			const canvas = webix.html.create("canvas");
			const ctx = canvas.getContext("2d");
			canvas.width = position.width;
			canvas.height = position.height;
			ctx.drawImage(img, 0, 0, position.width, position.height);

			imagePromise.resolve({
				data: canvas.toDataURL("png"),
				position
			});
		};
	}
	return imagePromise;
}

export function cloneNodeWithStyles(node){
	const clone = node.cloneNode(false);

	if(node.tagName){
		const styles = window.getComputedStyle(node);
		let cssText = "";
		for (let i = 0; i < styles.length; i++) {
			let prop = styles[i];
			if(prop == "visibility") continue;
			cssText += prop + ":" + styles.getPropertyValue(prop) + ";";
		}
		clone.style.cssText = cssText;
	}

	for (let i = 0; i < node.childNodes.length; i++)
		clone.appendChild(cloneNodeWithStyles(node.childNodes[i]));

	return clone;
}